import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable */
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useStoreState } from "pullstate";
import { get, set } from "lodash";
import { add } from "date-fns";
import Store from "../../utils/Store";
import Button from "../common/Button";
import Filters from "./Filters";
import { patientsExportService } from "../ExportMessage/services/downloadService";
import { formatFiltersObj } from "../SearchFilters/utils";
import { isValidDate } from "../../utils";
import getEnv from "../../utils/getEnv";
var initialFilters = {
  dateRange: [null, null],
  site: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  }
};
var ExportData = function ExportData(props) {
  var onClose = props.onClose;
  var _useState = useState(initialFilters),
    filters = _useState[0],
    setFilters = _useState[1];

  // for enabling only tb in the filters usecase dropdown
  var isUsecaseDisabled = getEnv("NEXT_PUBLIC_DISABLE_OTHER_USECASE") === "true";
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        downloadProgress: store.downloadProgress,
        isStartingDownload: store.isStartingDownload
      };
    }),
    downloadProgress = _useStoreState.downloadProgress,
    isStartingDownload = _useStoreState.isStartingDownload;
  useEffect(function () {
    if (isUsecaseDisabled) {
      initialFilters.usecase = "tb";
    }
  }, [isUsecaseDisabled]);
  var getFormattedFilters = function getFormattedFilters(filters) {
    var usecase = filters.usecase;
    var formattedFilters = formatFiltersObj(filters);
    var portalusecases = undefined;
    switch (usecase) {
      case "tb":
        portalusecases = ["tb"];
        break;
      case "tb_lung_cancer":
        portalusecases = ["tb", "lung_cancer"];
        break;
      case "lung_cancer":
        portalusecases = ["lung_cancer"];
        break;
      case "stroke":
        portalusecases = ["stroke"];
        break;
      default:
        break;
    }
    var startDate = get(formattedFilters, ["start_study_date"], "");
    var endDate = get(formattedFilters, ["end_study_date"], "");
    if (startDate) {
      var startDateVal = new Date(startDate);
      var endDateVal = add(new Date(endDate), {
        days: 1
      });
      if (isValidDate(startDateVal) && isValidDate(endDateVal)) {
        startDateVal.setHours(0, 0, 0);
        endDateVal.setHours(0, 0, 0);
        set(formattedFilters, ["start_study_date"], startDateVal.toISOString());
        set(formattedFilters, ["end_study_date"], endDateVal.toISOString());
      }
    }
    return _objectSpread(_objectSpread({}, formattedFilters), {}, {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      usecases: portalusecases
    });
  };
  var startDownload = function startDownload() {
    if ((downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload) {
      Store.update(function (s) {
        s.isExportReady = false;
        s.downloadProgress = 1;
        s.exportGenFailed = false;
        s.isStartingDownload = true;
      });
      var url = "patients_export/start_generation/";
      var formattedFilters = getFormattedFilters(filters);
      patientsExportService(url, formattedFilters).then(function (response) {
        Store.update(function (s) {
          s.isStartingDownload = false;
        });
        if (response !== null && response !== void 0 && response.success) {
          Store.update(function (s) {
            s.isExportReady = false;
            s.downloadProgress = 1;
            s.exportGenFailed = false;
          });
        }
      })["catch"](function (resp) {
        Store.update(function (s) {
          s.isExportReady = false;
          s.downloadProgress = 0;
          s.exportGenFailed = true;
          s.isStartingDownload = false;
        });
      });
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "m-4 flex flex-col text-left space-y-4 h-full"
  }, /*#__PURE__*/React.createElement(Filters, {
    filters: filters,
    setFilters: setFilters,
    isUsecaseDisabled: isUsecaseDisabled
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-row justify-end p-4 border-t border-t-gray-600"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "grow-1 w-full sm:w-40",
    onClick: onClose
  }, t("button.cancel")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    onClick: startDownload,
    className: "sm:mt-0 grow-1 ml-4 w-full sm:w-40"
  }, t("export_data"))));
};
export default ExportData;